<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Repayment and loan term</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Select repayment</mat-label>
          <mat-select placeholder="Select repayment" formControlName="repaymentFrequency">
            <mat-option *ngFor="let repayment of repaymentTypes" [value]="repayment.id">{{repayment.text}}</mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'repaymentFrequency'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Select loan term</mat-label>
          <mat-select placeholder="Select loan term" formControlName="loanTermId" (selectionChange)="updateTerm($event.value)" [disabled]="!enableLoanTerms">
            <mat-option *ngFor="let term of loanTerms" [value]="term.slug">{{term.name}}</mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'loanTermId'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
</mat-card>
